import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { UploaderType } from 'src/shared/types';

export type SiteFilesState = {
    searchText: string;
    uploadedByFilter: Record<UploaderType, boolean>;
};

const initialState: SiteFilesState = {
    searchText: '',
    uploadedByFilter: { [UploaderType.NatureMetrics]: true, [UploaderType.Client]: true },
};

const siteFilesSlice = createSlice({
    name: 'siteFiles',
    initialState,
    reducers: {
        setSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setUploadedByFilter: (state, action: PayloadAction<{ key: UploaderType; value: boolean }>) => {
            state.uploadedByFilter[action.payload.key] = action.payload.value;
        },
        resetFilters: state => {
            state.searchText = '';
            state.uploadedByFilter = { [UploaderType.NatureMetrics]: true, [UploaderType.Client]: true };
        },
    },
});

export const { setSearchText, setUploadedByFilter, resetFilters } = siteFilesSlice.actions;

export const getSiteFilesState = (state: RootState) => state.projects.siteFiles;
export const getSearchText = (state: RootState) => getSiteFilesState(state).searchText;
export const getUploadedByFilter = (state: RootState) => getSiteFilesState(state).uploadedByFilter;

export default siteFilesSlice.reducer;
